import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Auth } from 'aws-amplify';
import { defer, of, throwError } from 'rxjs';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserStoreService } from './user-store.service';
import { StorageService } from '../storage/storage.service';
import { GlobalService } from '../global/global.service';
import * as SecureLS from 'secure-ls';
import { Observable } from 'rxjs';

export interface ICuc {
  asociados?: {
    nomCompleto: string;
    numDocumento: string;
    tipoDocumento: string;
  }[];
  cuc: string;
  tipoCuenta: string;
  flagVerOperacion: string;
  parametroSistema: string;
  segmento: string;
  tipoMancomuno: string;
  docTitular: string;
  tipoDocTitular: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserRequestsService {
  //
  constructor(
    public userStore: UserStoreService,
    private http: HttpClient,
    private router: Router,
    private storageService: StorageService,
    private globalService: GlobalService
  ) {}

  authSignIn(password) {
    return defer(() => Auth.signIn(`${this.userStore.documentType}${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`, password));
  }

  getCurrentAuthData() {
    return defer(() => Auth.currentAuthenticatedUser());
  }

  changeCUC(CUC) {
    this.userStore.activeCUC = CUC;
    this.storageService.storeActiveCUC(CUC).subscribe(() => {
      window.location.reload();
    });
  }

  authForgotPassword() {
    return defer(() => Auth.forgotPassword(`${this.userStore.documentType}${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`)).pipe(
      catchError((apiResponse) => this.catchAuthForgotPassword(apiResponse))
    );
  }

  catchAuthForgotPassword(errorResponse) {
    if (errorResponse.code === 'LimitExceededException') {
      this.goToAttemptsOut();
    }
    if (errorResponse.code === 'NotAuthorizedException') {
      this.goToAttemptsOut();
    }
    return throwError(errorResponse);
  }

  authForgotPasswordSubmit(password = 'TempPassword2020$', user?) {
    return defer(() => Auth.forgotPasswordSubmit(user ? user : this.userStore.COGNITO_USER, this.userStore.COGNITO_TOKEN, password)).pipe(
      catchError((apiResponse) => this.catchAuthForgotPasswordSubmit(apiResponse))
    );
  }

  catchAuthForgotPasswordSubmit(errorResponse) {
    if (errorResponse.code === 'InvalidPasswordException') {
      //
      this.router.navigate(['oops']);
    }

    if (errorResponse.code === 'LimitExceededException') {
      //
      this.router.navigate(['oops']);
    }

    return throwError(errorResponse);
  }

  authCompleteNewPassword(password, user?) {
    return defer(() => Auth.completeNewPassword(user ? user : this.userStore.COGNITO_USER, password));
  }

  authGetCurrentSession() {
    return defer(() => Auth.currentSession());
  }

  authChangePassword(password,newPassword?, user?) {
    return defer(() => Auth.changePassword(user ? user : this.userStore.COGNITO_USER,password , newPassword));
  }

  authVerifyTotpToken(user?, token?) {
    return defer(() => Auth.verifyTotpToken(user ? user : this.userStore.COGNITO_USER, token ? token : this.userStore.COGNITO_TOTP_TOKEN));
  }

  getUserHiddenTokenData() {
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http
      .get(`${apiLogin}/public/token/contactos/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`)
      .pipe(catchError((errorResponse) => this.catchErrorHiddenToken(errorResponse)));
  }

  catchErrorHiddenToken(errorResponse) {
    if (errorResponse.error) {
      if (errorResponse.error.resultado.mensaje === 'Usuario no encontrado') {
        this.router.navigate(['/usuario-no-existe']);
      }
    }
    return throwError(errorResponse);
  }

  getUserCUC() {
    const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
    return this.http.get(`${apiFondos}/cliente/private/obtenerCucs/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`).pipe();
   // return this.http.get(`${apiFondos}/cliente/private/obtenerCucs/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`).pipe();

    //return this.http.get(`http://localhost:8080/api/fondos/cliente/obtenerCucs/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`).pipe();
  }

  /*getParametria() {
    //const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
    //return this.http.get(`${apiFondos}/cliente/private/obtenerCucs/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}`).pipe();
    return this.http.get(`http://localhost:8080/api/fondos/cliente/obtenerparametros`).pipe();
  }
    getParametria(): Observable<any> {
      const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
      return this.http.get(`${apiFondos}/cliente/private/obtenerparametros`);
    }
*/
  getCurrentAuth() {
    return defer(() => Auth.currentSession());
  }

  getUserAdviser() {
    const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
    return this.http
      .get(`${apiFondos}/cliente/private/obtenerAsesor/${this.userStore.activeCUC.cuc}`)
      .pipe(map((apiResponse) => this.fillGetUserAdviser(apiResponse)));
  }

  fillGetUserAdviser(apiResponse: any) {
    this.userStore.adviserData = apiResponse.datos;
    if (this.userStore.adviserData && this.userStore.adviserData.nombre) {
      this.userStore.adviserData.nombre = this.userStore.adviserData.nombre.toLowerCase().replace(/\b\w/g, (m) => {
        return m.toUpperCase();
      });
    }
  }

  sendUserToken(channel) {
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http.post(`${apiLogin}/public/token/canal/${this.userStore.documentType}/${this.userStore.document}${this.userStore.cuc?this.userStore.cuc:''}/${channel}`, {}).pipe();
  }

  redirectToOldVersion(token) {
    return this.http
      .post(
        this.globalService.globalEnvironments.oldVersion,
        {
          jtoken: token,
        },
        {
          headers: {
            jtoken: token,
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8'
          },
          withCredentials: true,
          observe: 'response',
          responseType: 'text',
          reportProgress: true,
        }
      )
      .pipe();
  }

  goToAttemptsOut() {
    this.router.navigate(['/intentos-agotados']).then(() => {
      this.resetUserData();
      this.resetCognito();
    });
  }

  resetCognito() {
    return defer(() => Auth.signOut()).pipe(tap(() => this.doResetCognito()));
  }

  refreshToken() {
    return this.getCurrentAuthData().pipe(concatMap((auth) => this.refreshSession(auth)));
  }

  refreshSession(auth) {
        var tab = this.getTabId()
        console.log('tre?'+tab);
        if(!tab){
          localStorage.clear();
          //this.storage.reset();
          //resolve(false);
        }

    return this.authGetCurrentSession().pipe(
      map((e: any) => {
        auth.refreshSession(e.refreshToken, (err, session) => {
          const { idToken } = session;
          this.userStore.authToken_ = idToken;
          this.storageService.storeUserSession(session).subscribe(() => {
            this.userStore.authToken = idToken;
          });
        });
      })
    );
  }

  saveUserSessionTime(){
    var ls = new SecureLS({encodingType: 'aes'});
        var current_time = new Date().getTime() / 1000;
        var iat = ls.get('iat')?ls.get('iat'):0; 


    const apiFondos = this.globalService.globalEnvironments.apiEndpoint.apiFondos;
    return this.http
    .get(`${apiFondos}/cliente/private/grabarIndicadorTiempo/${this.userStore.activeCUC.cuc}/${iat}/${current_time}`);      
  }

  doResetCognito() {
    this.userStore.COGNITO_TOKEN = '';
    this.userStore.COGNITO_CODE = '';
    this.userStore.COGNITO_USER = '';
    this.userStore.activeCUC = null;
    this.userStore.authToken = null;
    this.userStore.authToken_ = null;
    this.userStore.userCUC = null;
    this.userStore.adviserData = null;
    this.userStore.COGNITO_USER_DATA = null;
  }

  resetUserData() {
    this.userStore.document = '';
    this.userStore.documentType = '';
  }

  getTabId() {
    var ls = new SecureLS({encodingType: 'aes'});
    var tab = ls.get('tab')?ls.get('tab'):0; 



    if(tab){
      if(tab != sessionStorage.tabID){
        return false;
      }
    }
    /*
    if(sessionStorage.tabID){
      if(tab != sessionStorage.tabID){
        return false;
      }
    }*/
    else{
      var array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      var tabID = sessionStorage.tabID = array[0];
      ls.set('tab', tabID); 
    }


    return true;
  }

  sendUserPassword(clave,doc) {
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http.post(`${apiLogin}/public/usuario/clave/validar/${doc.toUpperCase()}`, {
      "clave":clave
    }).pipe();
  }

  saveUserPassword(clave,doc) {
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http.post(`${apiLogin}/public/usuario/clave/grabar/${doc.toUpperCase()}`, {
      "clave":clave
    }).pipe();
  }

  reenviarCorreo(tipo,doc) {    
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http.get(`${apiLogin}/public/usuario/clave/correo/${tipo}/${doc}`).pipe();
  }

  reenviarCorreoWeb(tipo,doc) {    
    const apiLogin = this.globalService.globalEnvironments.apiEndpoint.apiLogin;
    return this.http.get(`${apiLogin}/public/usuario/clave/correo/reenvio/${tipo}/${doc}`).pipe();
  }

/**
 *  @RequestParam(required = true) String cuc,
            @RequestParam(required = true) String segmento,
            @RequestParam(required = true) String tipoDocumento,
            @RequestParam(required = true) String numeroDocumento,
            @RequestParam(required = true) String fecha,
            @RequestParam(required = true) String opcion
 */

  setLogRendimientosUser(params){
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/consultas/private/insertarLogs/${params.CUC}`, {
        params: new HttpParams({
          fromObject: {
            cuc: params.CUC,
            segmento: params.segmento,
            opcion: params.opcion
          },
        }),
      }).pipe();    
      
/*
        return this.http
          .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/cuentaBancaria/registrar`,params)
  */    
    /*
      return this.http
      .get(`http://localhost:8080/api/fondos-consultas-service/insertarLogs`,{
        params: new HttpParams({
          fromObject: {
            cuc: params.CUC,
            segmento: params.segmento,
            tipoDocumento: this.userStore.documentType,
            numeroDocumento: this.userStore.document,
            opcion: params.opcion
          },
        }),
      }) 
  }*/
}
}